export function createCsvBlob(rows: string[][]): Blob {
  const csv = rows.map((row) => row.map((value) => `"${value.replace(/"/g, '""')}"`).join(',')).join('\n');
  const blob = new Blob(['\uFEFF', csv], {type: 'text/csv;charset=utf-8;'});
  return blob;
}
